/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1504
 */

"use strict"

exports.a = function () {
  return false
}
